import {
  SET_BUTTON_CHANNEL,
  SET_BUTTON_PROGRAM_CHANGE,
  SET_BUTTON_BANK_SELECT,
  SET_BUTTON_NOTE,
  SET_BUTTON_CC
} from './actionTypes'

export const setButtonChannel = (index, channel) => ({ type: SET_BUTTON_CHANNEL, index: index, channel: channel });
export const setButtonProgramChange = (index, patch) => ({ type: SET_BUTTON_PROGRAM_CHANGE, index: index, patch: patch });
 // TODO: convert to MSB/LSB
export const setButtonBankSelect = (index, msb, lsb) => {
  return {
    type: SET_BUTTON_BANK_SELECT,
    index: index,
    bankMSB: msb,
    bankLSB: lsb
  }
};
export const setButtonNote = (index, note) => ({ type: SET_BUTTON_NOTE, index: index, note: note });
export const setButtonCC = (index, cc) => ({ type: SET_BUTTON_CC, index: index, cc: cc });
